import React, { useState } from "react";
import { useDetailsContext } from "../details";
import { pdfjs } from "react-pdf";

import { Spinner } from "reactstrap";
import { ReactComponent as MobileSvg } from "../../assets/i_mobile.svg";

import "../../assets/OpenSans-Bold-bold"
import "../../assets/OpenSans-Regular-normal"

import { MobileSplitsValues } from "./MobileSplitsValues";
import { MobileSplitsHeader } from "./MobileSplitsHeader";
import { MobileSplitsTable } from "./MobileSplitsTable";

const MobileImgSplits = ({ activityDetails, handleDownloadPNG }) => {
  const [state] = useDetailsContext();
  const hasData = !!state.selectedRoute;
  const summaryUnitLabels = state.userPrefUnits;
  const [isLoading, setLoad] = useState(false);

  if (! hasData) {
    return <div/>;
  }

  const createPNG = async () => {
    setLoad(true);
    const jsPDF = await import("jspdf");
    const autoTable = await import("jspdf-autotable");
    const createZipFile = await import("../../../services/createZipFile");

    print(jsPDF.default, autoTable.default, createZipFile.default).then((pdf) => {
      const arrayBuffer = pdf.output("arraybuffer");
      pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
      const loadingTask = pdfjs.getDocument(arrayBuffer);

      loadingTask.promise.then((pdf) => {
        const totalPages = pdf.numPages;
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        const pngFiles = []; // Array to store file objects

        const renderPage = (pageNumber) => {
          return new Promise((resolve, reject) => {
            pdf.getPage(pageNumber).then((page) => {
              const viewport = page.getViewport({ scale: 1 });
              canvas.width = viewport.width;
              canvas.height = viewport.height;

              const renderTask = page.render({
                canvasContext: context,
                viewport: viewport,
              });

              renderTask.promise.then(() => {
                const pngDataUrl = canvas.toDataURL("image/png");
                const currentTime = new Date();
                const currentLocaleDate = currentTime.toLocaleDateString();
                const filename = `${currentLocaleDate}_${activityDetails.title}_Splits_${pageNumber}_waldup.png`;

                pngFiles.push({ filename, dataUrl: pngDataUrl });

                // Create a temporary <a> element to trigger the download
                // const downloadLink = document.createElement('a');
                // downloadLink.href = pngDataUrl;
                // downloadLink.download = filename;
  
                // Programmatically trigger the download
                // downloadLink.click();
  
                resolve();
              });
            });
          });
        };

        const renderAllPages = async () => {
          for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
            await renderPage(pageNumber);
          }

          const currentTime = new Date();
          const currentLocaleDate = currentTime.toLocaleDateString();
          const downloadLink = document.createElement("a");

          if (totalPages > 1) {
            // Create the zip file
            const zipData = await createZipFile.default(pngFiles);
            const zipFilename = `${currentLocaleDate}_${activityDetails.title}_MobileSplit.zip`;
            downloadLink.href = URL.createObjectURL(zipData);
            downloadLink.download = zipFilename;
            downloadLink.click();
            setLoad(false);
          }
          else {
            downloadLink.href = pngFiles[0].dataUrl;
            downloadLink.download = pngFiles[0].filename;

            // Programmatically trigger the download
            downloadLink.click();
            setLoad(false);
          }
        };

        renderAllPages();
      });
    });
  };

  const print = async (jsPDF) => {
    const waypointDataSimple = MobileSplitsValues(state.waypoints, summaryUnitLabels);
    const pdf = new jsPDF("p", "px", [1080, 1920]);
    pdf.setFont('OpenSans-Regular','normal');
    MobileSplitsHeader(pdf, activityDetails, summaryUnitLabels);
    const startTableY = 350;
    MobileSplitsTable(pdf, startTableY, summaryUnitLabels, waypointDataSimple);
    return pdf;
  };

  return (
    <React.Fragment>
      {/* While isLoading == true, show preloader */}
      {isLoading ? (
        <div className="wrapper">
          <span>Creating Mobile Splits ...</span>
          <Spinner className="spinner-border text-primary" animation="border" role="status">
          </Spinner>
        </div>
      ) : null}
      <div
        title="Create Mobile Splits"
        className="btn btn-light control-button"
        onClick={(e) => {
          state.userStripeLevel !== "free" ? createPNG() : handleDownloadPNG();
        }}
      >
        <i className="activity_icons"><MobileSvg /></i>
          Mobile Splits
      </div>
    </React.Fragment>
  );
};

export default MobileImgSplits;
